import { useEffect } from "react";
import {
  enqueueFirstWinsChatTrigger,
  scheduleTrackedChatTriggerDelay,
} from "@/hooks/chat/helpers/chatTriggerCoordinator";

export const useCustomEventTrigger = ({
  enabled,
  timeout = 5,
  popModal,
  triggerChat,
  eventName,
  triggerSource,
  triggerKey,
  sessionEpoch = 0,
}) => {
  useEffect(() => {
    let cancelCountdown;

    const listener = () => {
      if (cancelCountdown) cancelCountdown();
      cancelCountdown = scheduleTrackedChatTriggerDelay(
        triggerKey,
        triggerSource || "FAQs",
        timeout,
        () => {
          enqueueFirstWinsChatTrigger(() => {
            triggerChat(triggerSource, {
              popModal,
              triggerKey,
              ...(!enabled && { isProxyEvent: true }),
            });
          });
        },
      );
    };

    document.addEventListener(eventName, listener);

    return () => {
      document.removeEventListener(eventName, listener);
      if (cancelCountdown) cancelCountdown();
    };
  }, [
    enabled,
    timeout,
    popModal,
    triggerChat,
    eventName,
    triggerSource,
    triggerKey,
    sessionEpoch,
  ]);
};
